const KEY = 'ibe.roundTrip';

export type RoundTripHolds = {
  outboundId: string;
  returnId: string;
};

export function departsAfter(departureAt: string, earliestAt: string): boolean {
  const departure = new Date(departureAt).getTime();
  const earliest = new Date(earliestAt).getTime();
  if (Number.isNaN(departure) || Number.isNaN(earliest)) return false;
  return departure > earliest;
}

export type FlightOffer = 'open' | 'unpriced' | 'soldOut' | 'closed';

/** An open flight with no fare is not sold out — it simply cannot be selected yet. */
export function offerState(flight: {
  bookable?: boolean;
  totalFare: number | null;
  flightStatus?: string;
}): FlightOffer {
  if (flight.flightStatus && flight.flightStatus !== 'O') return 'closed';
  if (flight.totalFare == null) return 'unpriced';
  if (flight.bookable === false) return 'soldOut';
  return 'open';
}

const SELECTION_KEY = 'ibe.roundTrip.selection';

export type TripSelection<T> = {
  key: string;
  outbound: T | null;
  returnFlight: T | null;
};

export function saveTripSelection<T>(selection: TripSelection<T>) {
  sessionStorage.setItem(SELECTION_KEY, JSON.stringify(selection));
}

export function readTripSelection<T>(key: string): TripSelection<T> | null {
  try {
    const raw = sessionStorage.getItem(SELECTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<TripSelection<T>>;
    if (parsed.key !== key) return null;
    return { key, outbound: parsed.outbound ?? null, returnFlight: parsed.returnFlight ?? null };
  } catch {
    return null;
  }
}

export function saveRoundTripHolds(pair: RoundTripHolds) {
  sessionStorage.setItem(KEY, JSON.stringify(pair));
}

export function readRoundTripHolds(): RoundTripHolds | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<RoundTripHolds>;
    if (!parsed.outboundId || !parsed.returnId) return null;
    return { outboundId: parsed.outboundId, returnId: parsed.returnId };
  } catch {
    return null;
  }
}

export function clearRoundTripHolds() {
  sessionStorage.removeItem(KEY);
}
